import {getNeighborUnits} from "./getNeighborUnits";

export const getNeighborEnemyUnits = (ownerId, hexKey, units) => {
  const neighborUnits = getNeighborUnits(hexKey, units)
  return neighborUnits.filter(otherUnit => otherUnit.ownerId !== ownerId);
}